import { Tooltip } from "antd";
import { QuestionCircleOutlined } from "@ant-design/icons";
import { ReactNode } from "react";

export interface FieldInfoProps {
  readonly title?: ReactNode;
}

// Small "?" icon with a hover tooltip, used to explain non-self-explanatory form fields. Renders nothing when there
// is no title so call sites can pass an optional tooltip unconditionally.
function FieldInfo(props: FieldInfoProps) {
  if (!props.title) return null;
  return (
    <Tooltip title={props.title}>
      <QuestionCircleOutlined className="ml-1 cursor-help text-gray-400" />
    </Tooltip>
  );
}

export default FieldInfo;
